export enum Relationship {
  Self = '001',
  Child = '002',
  Spouse = '003',
  Father = '004',
  Mother = '005',
  Brother = '006',
  Sister = '007',
  Nephew = '008',
  Uncle = '9',
  Financial = '10',
  Aunty = '11',
  // Niece = 12,
  // Friend = 13,
  // Grand_Father = 14,
  // Grand_Mother = 15,
  // Grand_Child = 16,
  // Step_Mother = 17,
  // Step_Father = 18,
  // Step_Brother = 19,
  // Step_Sister = 2,
  // Partner = 21,
  // Brother_in_Law = 23,
  // Sister_in_Law = 24,
  // Employer = 25,
  // Daughter = 26,
  // Son = 27,
  // Step_Daughter = 28,
  // Step_Son = 29,
  // Adopted_Daughter = 3,
  // Adopted_Son = 31,
  // Grand_Daughter = 32,
  // Grand_Son = 33,
  // God_Daughter = 34,
  // God_Son = 35,
  // God_Father = 36,
  // God_Mother = 37,
  // Foster_Father = 38,
  // Foster_Mother = 39,
  // Father_In_Law = 4,
  // Mother_In_Law = 41,
  // Son_In_Law = 42,
  // Daughter_In_Law = 43,
  // Cousin_Brother = 44,
  // Cousin_Sister = 45,
  // Fiance_Fiancee = 46,
  // Husband = 47,
  // Wife = 48,
  // Legal_Guardian = 49,
  // Relative = 5,
  // Others = 51,
  // Affinity_Group = 52,
  // Employer_Group = 53,
  // Other_Family = 54,
}
